"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

// Source: /frontend/js/src/preact-components/assets/icon-radio-unchecked.tsx
var RadioUnchecked = function RadioUnchecked(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    focusable: "false"
  }, props), (0, _preact.h)("g", {
    id: "a-radio-button"
  }, (0, _preact.h)("circle", {
    id: "unselected",
    cx: "12",
    cy: "12",
    r: "7.5",
    fill: "white",
    stroke: props.stroke || '#D5D6DA'
  })));
};

var _default = RadioUnchecked;
exports.default = _default;